export const API_URL = process.env.REACT_APP_API_URL || 'https://api-lp.spores.dev';

export const NETWORK_CHAIN_IDS = process.env.REACT_APP_NETWORK_CHAIN_IDS || '0x61';

export const ACTIVE_POOL = process.env.REACT_APP_ACTIVE_POOL || '0';
